import React, { useEffect, useRef, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import { BASE_URL } from '../../../config/axios';
import axios from 'axios';
import { handleErrorToast, sortProjects } from '../../CustomFunctions';
import { useLocation } from 'react-router-dom';
import { DynamicImprestApprovalTable, DynamicsExpenseApproveTable, DynamicOfficeBillingTable, DynamicVehicleApprovalTable, DynamicBOQApprovalTable } from './DynamicApprovalTables';
import Dashboardnavbar from '../../../layout/Dashboardnavbar';
import StatusBar from '../../StatusBar/StatusBar';
import { Award, Building2, FileText, ReceiptIndianRupee, Truck, Wallet } from 'lucide-react';


const DynamicRequestsManagementTab = () => {

    const location = useLocation();
    const firsttoggle = location.state !== null ? location.state?.firsttoggle : 1;
    const requesttoggle = location.state !== null ? location.state?.requesttoggle ? location.state?.requesttoggle : 1 : 1;
    const [toggleState, setToggleState] = useState(requesttoggle);
    const role = sessionStorage.getItem('sitemanagement_role');

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return "Office Billing Request";
            case 2:
                return "Vehicle Billing Request";
            case 3:
                return 'Site Imprests Requests';
            case 4:
                return 'Site Expenses Requests';
            case 5:
                return 'Invoice Billing Requests';
            case 6:
                return 'BOQ Requests';
            default:
                return 'Office Billing Request';
        }
    };

    const [officeStats, setOfficeStats] = useState({});
    const [officeStatsLoading, setOfficeStatsLoading] = useState(false);
    const [vehicleStats, setVehicleStats] = useState({});
    const [vehicleStatsLoading, setVehicleStatsLoading] = useState(false);
    const [imprestStats, setImprestStats] = useState({});
    const [imprestStatsLoading, setImprestStatsLoading] = useState(false);
    const [expenseStats, setExpenseStats] = useState({});
    const [expenseStatsLoading, setExpenseStatsLoading] = useState(false);

    const getOfficeStats = async () => {
        setOfficeStatsLoading(true);
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/officerentfilterStats/null/null/`);
            setOfficeStats(res.data);

        } catch (error) {
            handleErrorToast(error);
        } finally {
            setOfficeStatsLoading(false);
        }
    };

    const getVehicleStats = async () => {
        setVehicleStatsLoading(true);
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/vehiclebillingfilterStats/null/null/`);
            setVehicleStats(res.data);

        } catch (error) {
            handleErrorToast(error);
        } finally {
            setVehicleStatsLoading(false);
        }
    };

    const getImprestStats = async () => {
        setImprestStatsLoading(true);
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/imprestfilterStats/null/null/`);
            setImprestStats(res.data);

        } catch (error) {
            handleErrorToast(error);
        } finally {
            setImprestStatsLoading(false);
        }
    };

    const getExpenseStats = async () => {
        setExpenseStatsLoading(true);
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/imprestfilterStats/null/null/`);
            setExpenseStats(res.data);

        } catch (error) {
            handleErrorToast(error);
        } finally {
            setExpenseStatsLoading(false);
        }
    };

    useEffect(() => {
        getVehicleStats();
        getOfficeStats();
        getImprestStats();
        getExpenseStats();
    }, [])

    const tabs = [
        { id: 1, label: 'Office Billing Request', icon: Building2 },
        { id: 2, label: 'Vehicle Billing Request', icon: Truck },
        { id: 3, label: 'Imprest Requests', icon: Wallet },
        { id: 4, label: 'Expense Requests', icon: ReceiptIndianRupee },
        { id: 5, label: 'BOQ Requests', icon: FileText },
        // { id: 6, label: 'Tender Requests', icon: Award },
    ];

    const renderActiveComponent = () => {
        switch (toggleState) {
            case 1: return <DynamicOfficeBillingApprovalStages />;
            case 2: return <DynamicVehicleBillingApprovalStages />;
            case 3: return <DynamicImprestApprovalStages />;
            case 4: return <DynamicExpenseBillingApprovalStages />;
            case 5: return <DynamicBOQApprovalStages />;
            case 6: return <DynamicBOQApprovalStages />;
            default: return null;
        }
    };

    return (
        <>
            <div className="content-tabs">
                <div className="project-details-modern">
                    <div className="project-content-modern">
                        <div className="modern-tabs-container">
                            <div className="tabs-scroll" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                <div style={{ display: 'flex' }}>
                                    {tabs.map((tab) => {
                                        const Icon = tab.icon;
                                        return (
                                            <button
                                                key={tab.id}
                                                className={`modern-tab-btn ${toggleState === tab.id ? 'active' : ''}`}
                                                onClick={() => setToggleState(tab.id)}
                                            >
                                                <Icon size={16} />
                                                <span>{tab.label}</span>
                                                {toggleState === tab.id && <div className="active-indicator" />}
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>

                        <div className="tab-content-modern">
                            {renderActiveComponent()}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};



const DynamicImprestApprovalStages = () => {

    const location = useLocation();
    const firsttoggle = location.state !== null ? location.state?.firsttoggle : 3;
    // const secondtoggle = location.state !== null ? location.state?.secondtoggle : 0;
    // const secondtoggle = 0;
    const imprestStage = location.state !== null ? location.state?.imprestStage ? location.state?.imprestStage : 0 : 0;
    const [toggleState, setToggleState] = useState(imprestStage);
    const employee = sessionStorage.getItem('sitemanagement_emp_id')
    const role = sessionStorage.getItem('sitemanagement_role')

    console.log("toggleState")
    console.log(toggleState)
    const [dynamicApprovalStages, setDynamicApprovalStages] = useState([]);
    const [buffer, setBuffering] = useState(false); //buffering logic
    const getImprestApprovalStages = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {

            const pro = await axios.get(`${BASE_URL}/siteproject/dapprovalformatstagesbytype/Imprest/`);
            setDynamicApprovalStages(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    useEffect(() => {
        getImprestApprovalStages();
    }, []);


    useEffect(() => {
        if (dynamicApprovalStages?.approval_stages?.length > 0) {
            const matchedStages = dynamicApprovalStages.approval_stages.filter(stage =>
                (stage.role_name && stage.role_name === role) ||
                (stage.employee && stage.employee === employee)
            );

            if (matchedStages.length > 0) {
                setToggleState(imprestStage === 0 ? matchedStages[0].level : imprestStage);
            } else {
                setToggleState(0);
            }
        }
    }, [dynamicApprovalStages, role, employee]);

    const filteredStages = dynamicApprovalStages?.approval_stages
        ?.filter(stage =>
            (stage.role_name && stage.role_name === role) ||
            (stage.employee && stage.employee === employee)
        );

    return (
        <>
            <div>
                {
                    buffer ? <div className="spinner"></div> :
                        filteredStages?.length > 0
                            ?
                            <div className="bloc-tabs-with-white-bg">
                                {
                                    filteredStages?.map((stages, index) => {
                                        return (
                                            <button
                                                style={{
                                                    cursor: 'help'
                                                }}
                                                className={
                                                    toggleState === stages.level
                                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                                }
                                                title={`Stage for ${stages.permissions}`}
                                                // title={`${stages.permissions === 'Approve-Reject-Edit' ? '' : ''}`}
                                                onClick={() => setToggleState(stages.level)}
                                            >
                                                Imprest {stages.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stages.level}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                            :
                            <div className="bloc-tabs-with-white-bg justify-center">
                                Not Authorized For This Request Management
                            </div>
                }

                <div className="content-tabs-without-margin">

                    {filteredStages?.length > 0
                        &&
                        <DynamicImprestApprovalTable level={toggleState} />
                    }
                </div>
            </div>
        </>

    );
};

const DynamicExpenseBillingApprovalStages = () => {

    const location = useLocation();
    // const firsttoggle = location.state !== null ? location.state?.firsttoggle ? location.state?.firsttoggle : 1 : 1;
    // const secondtoggle = location.state !== null ? location.state?.secondtoggle : 0;
    // const secondtoggle = 0;
    // const requesttoggle = location.state !== null ? location.state?.requesttoggle ? location.state?.requesttoggle : 1 : 1;
    const expenseStage = location.state !== null ? location.state?.expenseStage ? location.state?.expenseStage : 0 : 0;
    const [toggleState, setToggleState] = useState(expenseStage);
    const employee = sessionStorage.getItem('sitemanagement_emp_id')
    const role = sessionStorage.getItem('sitemanagement_role')

    // console.log("expenseStage-", expenseStage)
    // console.log("toggleState")
    // console.log(toggleState)

    const [dynamicApprovalStages, setDynamicApprovalStages] = useState([]);
    const [buffer, setBuffering] = useState(false); //buffering logic
    const getImprestApprovalStages = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {

            const pro = await axios.get(`${BASE_URL}/siteproject/dapprovalformatstagesbytype/Expense/`);
            setDynamicApprovalStages(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    useEffect(() => {
        getImprestApprovalStages();
    }, []);


    useEffect(() => {
        if (dynamicApprovalStages?.approval_stages?.length > 0) {
            const matchedStages = dynamicApprovalStages.approval_stages.filter(stage =>
                (stage.role_name && stage.role_name === role) ||
                (stage.employee && stage.employee === employee)
            );

            if (matchedStages.length > 0) {
                setToggleState(expenseStage === 0 ? matchedStages[0].level : expenseStage);
            } else {
                setToggleState(0);
            }
        }
    }, [dynamicApprovalStages, role, employee]);

    const filteredStages = dynamicApprovalStages?.approval_stages
        ?.filter(stage =>
            (stage.role_name && stage.role_name === role) ||
            (stage.employee && stage.employee === employee)
        );

    return (
        <>
            <div>
                {
                    buffer ? <div className="spinner"></div> :
                        filteredStages?.length > 0
                            ?
                            <div className="bloc-tabs-with-white-bg">
                                {
                                    filteredStages?.map((stages, index) => {
                                        return (
                                            <button
                                                style={{
                                                    cursor: 'help'
                                                }}
                                                className={
                                                    toggleState === stages.level
                                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                                }
                                                title={`Stage for ${stages.permissions}`}
                                                // title={`${stages.permissions === 'Approve-Reject-Edit' ? '' : ''}`}
                                                onClick={() => setToggleState(stages.level)}
                                            >
                                                Expense {stages.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stages.level}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                            :
                            <div className="bloc-tabs-with-white-bg justify-center">
                                Not Authorized For This Request Management
                            </div>
                }

                <div className="content-tabs-without-margin">

                    {filteredStages?.length > 0
                        &&
                        <DynamicsExpenseApproveTable level={toggleState} />
                    }
                </div>
            </div>
        </>

    );
};

const DynamicOfficeBillingApprovalStages = () => {


    // const [toggleState, setToggleState] = useState(1);
    const location = useLocation();
    // const secondtoggle = location.state !== null ? location.state?.secondtoggle : 0;
    // const secondtoggle = 0;
    const officeStage = location.state !== null ? location.state?.officeStage ? location.state?.officeStage : 0 : 0;



    const [toggleState, setToggleState] = useState(officeStage);
    const employee = sessionStorage.getItem('sitemanagement_emp_id')
    const role = sessionStorage.getItem('sitemanagement_role')

    const [dynamicApprovalStages, setDynamicApprovalStages] = useState([]);
    const [buffer, setBuffering] = useState(false); //buffering logic
    const getStagesdata = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {

            const pro = await axios.get(`${BASE_URL}/siteproject/dapprovalformatstagesbytype/Office/`);
            setDynamicApprovalStages(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    useEffect(() => {
        getStagesdata();
    }, []);


    useEffect(() => {
        if (dynamicApprovalStages?.approval_stages?.length > 0) {
            const matchedStages = dynamicApprovalStages.approval_stages.filter(stage =>
                (stage.role_name && stage.role_name === role) ||
                (stage.employee && stage.employee === employee)
            );

            if (matchedStages.length > 0) {
                setToggleState(officeStage === 0 ? matchedStages[0].level : officeStage);
            } else {
                setToggleState(0);
            }
        }
    }, [dynamicApprovalStages, role, employee]);

    const filteredStages = dynamicApprovalStages?.approval_stages?.filter(stage =>
        (stage.role_name && stage.role_name === role) ||
        (stage.employee && stage.employee === employee)
    );

    return (
        <>
            <div>
                {
                    dynamicApprovalStages?.approval_stages
                        ?.filter(stage =>
                            (stage.role_name && stage.role_name === role) ||
                            (stage.employee && stage.employee === employee)
                        ).length > 0
                        ?
                        <div className="bloc-tabs-with-white-bg">
                            {
                                dynamicApprovalStages?.approval_stages
                                    ?.filter(stage =>
                                        (stage.role_name && stage.role_name === role) ||
                                        (stage.employee && stage.employee === employee)
                                    )
                                    ?.map((stages, index) => {
                                        console.log("stage.role_name:", stages.role_name)
                                        console.log("stage.employee:", stages.employee)
                                        return (
                                            <button
                                                className={
                                                    toggleState === stages.level
                                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                                }
                                                onClick={() => setToggleState(stages.level)}
                                            >
                                                Office {stages.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stages.level}
                                            </button>
                                        )
                                    })
                            }
                        </div>
                        :
                        <div className="bloc-tabs-with-white-bg justify-center">
                            Not Authorized For This Request Management
                        </div>
                }

                <div className="content-tabs-without-margin">
                    {console.log(filteredStages?.length, 'length')}
                    {filteredStages?.length > 0
                        &&
                        <DynamicOfficeBillingTable level={toggleState} />
                    }
                </div>
            </div>
        </>

    );
};

const DynamicVehicleBillingApprovalStages = () => {

    // const [toggleState, setToggleState] = useState(1);
    const location = useLocation();
    // const secondtoggle = location.state !== null ? location.state?.secondtoggle : 0;
    // const secondtoggle = 0;
    const vehicleStage = location.state !== null ? location.state?.vehicleStage ? location.state?.vehicleStage : 0 : 0;
    const [toggleState, setToggleState] = useState(vehicleStage);
    const employee = sessionStorage.getItem('sitemanagement_emp_id')
    const role = sessionStorage.getItem('sitemanagement_role')
    const [dynamicApprovalStages, setDynamicApprovalStages] = useState([]);
    const [buffer, setBuffering] = useState(false); //buffering logic
    const getVehicleStagesData = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {

            const pro = await axios.get(`${BASE_URL}/siteproject/dapprovalformatstagesbytype/Vehicle/`);
            setDynamicApprovalStages(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    useEffect(() => {
        getVehicleStagesData();
    }, []);


    useEffect(() => {
        if (dynamicApprovalStages?.approval_stages?.length > 0) {
            const matchedStages = dynamicApprovalStages.approval_stages.filter(stage =>
                (stage.role_name && stage.role_name === role) ||
                (stage.employee && stage.employee === employee)
            );

            if (matchedStages.length > 0) {
                setToggleState(vehicleStage === 0 ? matchedStages[0].level : vehicleStage);
            } else {
                setToggleState(0);
            }
        }
    }, [dynamicApprovalStages, role, employee]);

    const filteredStages = dynamicApprovalStages?.approval_stages?.filter(stage =>
        (stage.role_name && stage.role_name === role) ||
        (stage.employee && stage.employee === employee)
    );

    return (
        <>
            <div>
                {
                    dynamicApprovalStages?.approval_stages
                        ?.filter(stage =>
                            (stage.role_name && stage.role_name === role) ||
                            (stage.employee && stage.employee === employee)
                        ).length > 0
                        ?
                        <div className="bloc-tabs-with-white-bg">
                            {
                                dynamicApprovalStages?.approval_stages
                                    ?.filter(stage =>
                                        (stage.role_name && stage.role_name === role) ||
                                        (stage.employee && stage.employee === employee)
                                    )
                                    ?.map((stages, index) => {
                                        console.log("stage.role_name:", stages.role_name)
                                        console.log("stage.employee:", stages.employee)
                                        return (
                                            <button
                                                className={
                                                    toggleState === stages.level
                                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                                }
                                                onClick={() => setToggleState(stages.level)}
                                            >
                                                Vehicle {stages.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stages.level}
                                            </button>
                                        )
                                    })
                            }
                        </div>
                        :
                        <div className="bloc-tabs-with-white-bg justify-center">
                            Not Authorized For This Request Management
                        </div>
                }

                <div className="content-tabs-without-margin">

                    {filteredStages?.length > 0
                        &&
                        <DynamicVehicleApprovalTable level={toggleState} />
                    }
                </div>
            </div>
        </>

    );
};

const DynamicInvoiceBillingApprovalStages = () => {

    const [dynamicApprovalStages, setDynamicApprovalStages] = useState([]);
    const location = useLocation();

    useEffect(() => {
        const stages = [
            { level: 1 }, { level: 2 }, { level: 3 }, { level: 4 }, { level: 5 }
        ];
        setDynamicApprovalStages(stages);
    }, []);
    console.log(dynamicApprovalStages);
    const secondtoggle = location.state !== null ? location.state?.secondtoggle : 1;

    const [toggleState, setToggleState] = useState(secondtoggle);

    const [buffer, setBuffering] = useState(false);

    return (
        <>
            <div>
                <div className="bloc-tabs-with-white-bg">
                    {
                        dynamicApprovalStages.map((i) => (
                            <button>
                                <button
                                    className={
                                        toggleState === i.level
                                            ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                            : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                    }
                                    onClick={() => setToggleState(i.level)}
                                >
                                    Invoice Stage {i.level}
                                </button>
                            </button>
                        ))
                    }
                </div>
            </div>
        </>
    )



}

const DynamicBOQApprovalStages = () => {

    const location = useLocation();
    const firsttoggle = location.state !== null ? location.state?.firsttoggle : 3;
    // const secondtoggle = location.state !== null ? location.state?.secondtoggle : 0;
    // const secondtoggle = 0;
    const subcompanyid = sessionStorage.getItem("sitemanagement_project_sub_company");
    const [sorting, setSorting] = useState("asc_pr");

    const [projectsList, setProjectsList] = useState([]);
    const [projects, setProjects] = useState("");
    const tenderStage = location.state !== null ? location.state?.tenderStage ? location.state?.tenderStage : 0 : 0;
    const [toggleState, setToggleState] = useState(tenderStage);
    const empID = sessionStorage.getItem('sitemanagement_emp_id')
    const siteRole = sessionStorage.getItem('sitemanagement_role')
    const [toggleCompany, setToggleCompany] = useState(subcompanyid || "null");

    console.log("toggleState")
    console.log(toggleState)
    const [dynamicApprovalStages, setDynamicApprovalStages] = useState([]);
    const [buffer, setBuffering] = useState(false); //buffering logic

    // const getBOQApprovalStages = async (filters = {}) => {
    //     setBuffering(true); //buffering logic // Start BufferingDD
    //     try {
    //         const params = new URLSearchParams();
    //         if (filters.id) params.append('id', filters.id);
    //         if (filters.sub_company) params.append('sub_company', filters.sub_company);
    //         if (filters.current_level) params.append('current_level', filters.current_level);
    //         if (filters.com_operator) params.append('com_operator', filters.com_operator);
    //         if (filters.current_status) params.append('current_status', filters.current_status);
    //         if (filters.previous_approval_status)
    //             params.append('previous_approval_status', filters.previous_approval_status);
    //         const query = params.toString();
    //         const queryString = query ? `?${query}` : '';

    //         let url;


    //         sessionStorage.getItem('sitemanagement_role') === 'AuthorityEngineer' ?
    //             url = `${BASE_URL}/siteproject/project_sub_company_BOQ_filter/${queryString}`
    //             : sessionStorage.getItem('sitemanagement_role') === 'DataEntryOperator' ?
    //                 url = `${BASE_URL}/siteproject/project_sub_company_BOQ_filter/${queryString}`
    //                 : siteRole === "SiteManagement" ?
    //                     url = `${BASE_URL}/siteproject/project_sub_company_BOQ_filter/${queryString}`
    //                     : url = `${BASE_URL}/siteproject/project_sub_company_BOQ_filter/${queryString}`;


    //         const ress = await axios.get(url);
    //         if (siteRole === "SiteManagement") {
    //             setProjects(ress.data);
    //         }
    //         else {
    //             const sortedList = sortProjects(ress.data, "site_prcode");

    //             setProjectsList(sortedList);
    //         }




    //     } catch (err) {
    //         //toast Logic
    //         handleErrorToast(err);
    //     } finally {
    //         setBuffering(false); // End Buffering
    //     }
    // };
    const getBOQApprovalStages = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {

            const pro = await axios.get(`${BASE_URL}/siteproject/dapprovalformatstagesbytype/BOQ/`);
            setDynamicApprovalStages(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    useEffect(() => {
        getBOQApprovalStages();
    }, []);


    useEffect(() => {
        if (dynamicApprovalStages?.approval_stages?.length > 0) {
            const matchedStages = dynamicApprovalStages.approval_stages.filter(stage =>
                (stage.role_name && stage.role_name === siteRole) ||
                (stage.employee && stage.employee === empID)
            );

            if (matchedStages.length > 0) {
                setToggleState(tenderStage === 0 ? matchedStages[0].level : tenderStage);
            } else {
                setToggleState(0);
            }
        }
    }, [dynamicApprovalStages, siteRole, empID]);

    const filteredStages = dynamicApprovalStages?.approval_stages
        ?.filter(stage =>
            (stage.role_name && stage.role_name === siteRole) ||
            (stage.employee && stage.employee === empID)
        );

    return (
        <>
            <div>
                {
                    dynamicApprovalStages?.approval_stages
                        ?.filter(stage =>
                            (stage.role_name && stage.role_name === siteRole) ||
                            (stage.employee && stage.employee === empID)
                        ).length > 0
                        ?
                        <div className="bloc-tabs-with-white-bg">
                            {
                                dynamicApprovalStages?.approval_stages
                                    ?.filter(stage =>
                                        (stage.role_name && stage.role_name === siteRole) ||
                                        (stage.employee && stage.employee === empID)
                                    )
                                    ?.map((stages, index) => {
                                        console.log("stage.role_name:", stages.role_name)
                                        console.log("stage.employee:", stages.employee)
                                        return (
                                            <button
                                                className={
                                                    toggleState === stages.level
                                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                                }
                                                onClick={() => setToggleState(stages.level)}
                                            >
                                                BOQ {stages.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stages.level}
                                            </button>
                                        )
                                    })
                            }
                        </div>
                        :
                        <div className="bloc-tabs-with-white-bg justify-center">
                            Not Authorized For This Request Management
                        </div>
                }

                <div className="content-tabs-without-margin">

                    {filteredStages?.length > 0
                        &&
                        <DynamicBOQApprovalTable level={toggleState} />
                    }
                </div>
            </div>
        </>

    );
};



export {
    DynamicRequestsManagementTab,
    DynamicImprestApprovalStages,
    DynamicExpenseBillingApprovalStages,
    DynamicOfficeBillingApprovalStages,
    DynamicVehicleBillingApprovalStages,
    DynamicInvoiceBillingApprovalStages,
    DynamicBOQApprovalStages,
}